import { postApi } from "../apis";

export const RegisterProperty = (data) => {
    return postApi('/api/property-management', data);
};